import { gql } from '@apollo/client';

export default gql`
  mutation confirmTierBenefitUpgrade($bookingReference: String!, $membershipNumber: String!) {
    confirmTierBenefitUpgrade(bookingReference: $bookingReference, membershipNumber: $membershipNumber) {
      success
    }
  }
`;
